import React from 'react';
import Page from '../templates/Page';
import { SEO } from '../components';
import { Intro, Superawesome, SAP, Sesame, Kiron, Blueberry, Personal, StickyNavigation } from '../compositions/Work';

/**
 * Work page
 */
const Work = () => (
  <>
    <Page preContent={<Intro />}>
      <StickyNavigation />
      <SEO title="Previous experience | Danijel Grabež" />
      <SAP />
      <Sesame />
      <Kiron />
      <Blueberry />
      <Superawesome />
      <Personal />
    </Page>
  </>
);

export default Work;
